import React, { Suspense } from "react";
import Loading from "../../static/Loading/Loading";

export const useLazyLoad = function<T>(Component: T) {
  return <Suspense fallback={Loading}>{Component}</Suspense>;
};
